
import React from 'react';
// material
import { Grid } from '@material-ui/core';
// entities
import { Campaign } from '../../../../entities/site';

interface CampaignHeaderProps {
  campaign: Campaign;
}

const CampaignHeader: React.FC<CampaignHeaderProps> = (props) => {

  return (
    <Grid container>
      <Grid item xs={4} style={styles.name}>{props.campaign.name}</Grid>
      <Grid item xs={8} style={styles.status}>
        <div style={styles.container}>
          <div style={styles.status}>{props.campaign.status}</div>
          <div style={styles.divider} />
          <div style={styles.date}><span style={styles.dateValue}>{props.campaign.messagesPerDay}</span> msg/day</div>
          <div style={styles.divider} />
          <div style={styles.date}><span style={styles.dateValue}>{props.campaign.daysOfWeek}</span></div>
          <div style={styles.divider} />
          <div style={styles.date}>Start Date: <span style={styles.dateValue}>{props.campaign.startDate}</span></div>
          <div style={styles.date}>End Date: <span style={styles.dateValue}>{props.campaign.endDate}</span></div>
        </div>
      </Grid>
    </Grid>
  );
};

export default CampaignHeader;

const styles = {
  name: {
    color: '#1B242E',
    fontSize: 20,
    paddingTop: 10,
    paddingBottom: 10
  },
  container: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  status: {
    color: '#29E2BF',
    fontSize: 16
  },
  divider: {
    width: 1,
    backgroundColor: '#E0E0E0',
    marginLeft: 20
  },
  date: {
    color: '#627995',
    fontSize: 14,
    marginLeft: 20
  },
  dateValue: {
    fontSize: 16,
    fontWeight: 800
  }
};


// WEBPACK FOOTER //
// ./src/pages/admin/campaign/components/CampaignHeader.tsx